import React from 'react';
import classNames from 'classnames';

const Variants = ({ variants, selectedVariant, onVariantSelected }) => {
  if (!variants || Object.keys(variants).length < 2) return null;

  return (
    <div className="d-flex flex-column mt-2">
      <strong className="title">Design Colour:</strong>
      <div className="d-flex flex-row">
        {Object.entries(variants).map(([key, { dominant_colours = [] }]) => (
          <div
            key={key}
            className={classNames(
              'dominant-colour d-flex mr-2',
              { selected: key === selectedVariant }
            )}
            data-test-id={key === selectedVariant ? 'selected' : 'unselected'}
          >
            <button
              className="btn dominant-colour-button align-self-center p-0"
              onClick={() => onVariantSelected(key)}
              style={{ background: dominant_colours[0] || '#fff' }}
              aria-label={`Select ${key} variant`}
              type="button"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Variants;
